
import React, { useEffect, useMemo, useRef, useState } from "react";
import "../../../assets/css/Attendance.css";
import "../../../assets/css/Modal.css";
import exporticon from '../../../assets/icons/export-data.svg';
import { format, addDays, subDays } from "date-fns";
import AdvanceTable from "../../../Utils/AdvanceTables";
import SearchingBar from "../../../Utils/Searching";
import AttendanceStatus from "../../../Component/AttendancStatus";
import absentEmp from '../../../assets/icons/absentEmployees.svg'
import presentEmp from '../../../assets/icons/presentemp.svg'
import latecomingEmp from '../../../assets/icons/employment-running-late-svgrepo-com.svg'
import DigitalClock from "../../../Utils/DigitalClock";
import AnalogWallClock from "../../../Utils/DigitalClock";
import { useNavigate } from "react-router-dom";
import SideDrawer from "../../../Utils/SideDrawer";
import AttendanceReport from "./AttendanceReport";

import { useWebSocket } from "../../../Utils/WebSocketHooks";
import { getBlob, getData } from "../../../API/GlobalApi";
import Notifier from '../../../Utils/notify.js';
import debounce from "lodash.debounce";
import SearchBar from "../../../Component/SearchBar.js";
import SpinnerLoader from "../../../Utils/Spinner.js";
import AttendanceEmployeeModal from "../../../Component/Modals/AttendanceEmployeeModal.js";
const AttendanceDashboard = ({ zoomedOut, setZoomedOut }) => {
    const [search, setSearch] = useState("");
    const [activeTab, setActiveTab] = useState("present");
    const [fromDate, setFromDate] = useState("");
    const getToday = () => new Date().toISOString().split("T")[0];

    const [toDate, setToDate] = useState(getToday());

    const [selectedDate, setSelectedDate] = useState(new Date());

    const [openReport, setOpenReport] = useState(false);
    const handlePrev = () => {
        setSelectedDate(prev => subDays(prev, 1));
    };

    const handleNext = () => {
        setSelectedDate(prev => addDays(prev, 1));
    }

    const [sortField, setSortField] = useState(null);
    const [sortOrder, setSortOrder] = useState(null);
    const [filterEmployee, setFilterEmployee] = useState([])
    const [filterQueryString, setFilterQueryString] = useState('');

    const handleSort = (field, order) => {
        //     setSortField(field);
        //     setSortOrder(order);
        //     setCurrentPage(0);
        //     setIsFilterApplied(false);
        //     setFilterFeeData([]);
        //     const queryParams = new URLSearchParams(filterQueryString || "");
        //     queryParams.set("type", field);
        //     queryParams.set("sort_by", order);
        //     const newQuery = queryParams.toString();
        //     setFilterQueryString(newQuery);

        //     // Fetch first page with new sort
        //     getStudents(0, field, order, newQuery);
    };






    const toggleZoom = async () => {
        if (!zoomedOut) {
            if (document.documentElement.requestFullscreen) {
                await document.documentElement.requestFullscreen();
            }
        } else {
            if (document.exitFullscreen) {
                await document.exitFullscreen();
            }
        }
        setZoomedOut(!zoomedOut);
    };

    //     const toggleZoom = () => {
    //   setZoomedOut(!zoomedOut);
    // };

    // keep state in sync with actual fullscreen changes (e.g., ESC key)
    useEffect(() => {
        const handleFullscreenChange = () => {
            if (!document.fullscreenElement) {
                setZoomedOut(false);
                // Reset any transforms immediately
                const dashboard = document.querySelector(".main-wrapper");
                if (dashboard) {
                    dashboard.style.transition = "none"; // prevent sliding animation
                    dashboard.style.transform = "none";

                    // Force reflow
                    dashboard.getBoundingClientRect();

                    // Restore transition
                    setTimeout(() => {
                        dashboard.style.transition = "transform 0.3s ease-in-out";
                    }, 10);
                }
            }
        };

        document.addEventListener("fullscreenchange", handleFullscreenChange);
        return () => {
            document.removeEventListener("fullscreenchange", handleFullscreenChange);
        };
    }, []);



    useEffect(() => {
        if (openReport) {
            document.body.style.overflow = 'hidden'; // disable scroll
        } else {
            document.body.style.overflow = 'auto'; // restore scroll
        }
        return () => {
            document.body.style.overflow = 'auto'; // cleanup
        };
    }, [openReport]);


    const [empData, setEmpData] = useState([])
    const [stats, setStats] = useState(null)

    const [loading, setLoading] = useState(false);


    // -------------------------------
    // WebSocket URL
    // -------------------------------
    // const WS_URL = "ws://192.168.1.44:9000/ws/staff/attendance/";
    const WS_URL = process.env.REACT_APP_API_WSS_URL_ATTENDANCE;
    console.log("WS_URL", WS_URL)
    // -------------------------------
    // Refresh APIs (attendance + stats)
    // -------------------------------
    const refreshAPIs = async () => {
        try {
            const apiDate = format(selectedDate, "yyyy-MM-dd");

            const [empRes, statsRes] = await Promise.all([
                getData(`staff/attendance/?date=${apiDate}`),
                getData(`staff/attendance-stats/?date=${apiDate}`)
            ]);

            setStats(statsRes?.data);
            return empRes;

        } catch (error) {
            console.error("API Refresh Error:", error);
            return null;
        }
    };

    // -------------------------------
    // WebSocket Hook
    // -------------------------------
    const { connected, readyState, connect, disconnect } = useWebSocket(WS_URL, {
        onOpen: () => console.log("WS Connected"),

        onMessage: async (msg) => {
            if (msg?.type === "connection" || !msg?.data) return;
            console.log("web socket on message", msg.data)
            const attendance = msg.data;

            // Notifier.success(
            //     `${attendance.employee_name} marked attendance (${attendance.status})`
            // );

            // Refresh APIs
            const apiList = await refreshAPIs();

            if (!apiList) return;

            // Force new array reference to trigger React re-render
            setEmpData(Array.isArray(apiList) ? [...apiList] : apiList);
        },


        onClose: () => console.log("WS Disconnected"),
        onError: (err) => console.error("WS Error:", err),
    });

    // -------------------------------
    // Auto Connect WebSocket
    // -------------------------------
    useEffect(() => {
        connect();
        return () => disconnect();
    }, []);

    // -------------------------------
    // Fetch initial data + on date change
    // -------------------------------
    useEffect(() => {
        fetchData();
    }, [selectedDate]);

    const fetchData = async () => {
        try {

            setLoading(true);
            const apiDate = format(selectedDate, "yyyy-MM-dd");

            const [empRes, statsRes] = await Promise.all([
                getData(`staff/attendance/?date=${apiDate}`),
                getData(`staff/attendance-stats/?date=${apiDate}`)
            ]);

            setEmpData(empRes);
            setStats(statsRes?.data);

        } catch (error) {
            Notifier.error(error);
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    };


    const handleSetSearchResults = (data) => {
        setFilterEmployee(Array.isArray(data) ? data : []);
    };






    const [currentTime, setCurrentTime] = useState("");

    useEffect(() => {
        const timer = setInterval(() => {
            const now = new Date();
            const hours = now.getHours().toString().padStart(2, "0");
            const minutes = now.getMinutes().toString().padStart(2, "0");
            const seconds = now.getSeconds().toString().padStart(2, "0");
            setCurrentTime(`${hours}:${minutes}:${seconds}`);
        }, 1000);
        return () => clearInterval(timer);
    }, []);



    function parseTimeStringToDate(timeString) {
        if (!timeString || timeString === "—") return null;

        // Create today’s date with that time
        const today = new Date();
        const [time, modifier] = timeString.split(" ");
        let [hours, minutes] = time.split(":");

        hours = parseInt(hours, 10);
        minutes = parseInt(minutes, 10);

        if (modifier === "PM" && hours < 12) {
            hours += 12;
        }
        if (modifier === "AM" && hours === 12) {
            hours = 0;
        }

        const date = new Date(today.getFullYear(), today.getMonth(), today.getDate(), hours, minutes);
        return date;
    }

    function calculateWorkingHours(clockIn, clockOut) {

        const inTime = parseTimeStringToDate(clockIn);
        const outTime = parseTimeStringToDate(clockOut);

        if (!inTime || !outTime) return "-";

        const diffMs = outTime - inTime;
        if (diffMs <= 0) return "-";

        const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
        const diffMinutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));

        return `${diffHours}h ${diffMinutes}m`;
    }





    const standardTime = 570; // 9:30 AM in minutes

    const noteColors = {
        "On time": { bg: "#E6F7EC", color: "#1E7E34" },         // green
        "Late clock-in": { bg: "#FFF7E6", color: "#D97706" },   // orange
        "Late check-in": { bg: "#FDE2E2", color: "#F59E0B" },   // red
        "Early arrival": { bg: "#E6F0FF", color: "#1D4ED8" },   // blue
        "Early check-in": { bg: "#E0F7FA", color: "#0E7490" },  // teal
    };
    const [selectedEmployee, setSelectedEmployee] = useState(null);
    const [summary, setSummary] = useState(null);
    const [selectedEmployeeId, setSelectedEmployeeId] = useState(null);
    const [loadingSummary, setLoadingSummary] = useState(false);

    const [reportMonth, setReportMonth] = useState(null);
    const [reportYear, setReportYear] = useState(null);

    const handleReportShow = async (row) => {
        const emp = row.original;
        setSelectedEmployeeId(emp?.employee_id)
        setOpenReport(true);
        setLoadingSummary(true);
        const month = selectedDate.getMonth() + 1; // month number for API
        const year = selectedDate.getFullYear();
        const url = `staff/attendance-summary/?employee_id=${emp.employee_id}&month=${month}&year=${year}`;
        try {
            const res = await getData(url);
            setSelectedEmployee(res?.data.employees || []);
            setSummary({
                month: res.data.month,
                year: res.data.year,
                total: res.data.total_employees
            });
            setReportMonth(res.data.month - 1); // JS months are 0-based
            setReportYear(res.data.year);
        } catch (error) {
            console.log("Error fetching summary:", error);
            Notifier.error("Failed to load attendance summary");
        } finally {
            setLoadingSummary(false);
        }
    };






    const columns = useMemo(
        () => [
            {
                Header: "Employee",
                accessor: "employee_name",
                disableSortBy: false,
                Cell: ({ row }) => (
                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                        {/* <img
                            src={row.original.profile_picture}
                            style={{
                                width: "30px",
                                height: "30px",
                                borderRadius: "50%",
                                objectFit: "cover",
                            }}
                        /> */}
                        <div>
                            <div style={{ fontWeight: 500, color: "rgb(34, 47, 62)" }}>
                                {row.original.employee_name}
                            </div>
                            <small style={{ color: "#6B778C" }}>{row.original.unique_code}</small>
                        </div>
                    </div>
                ),
            },
            // { Header: "Department", accessor: "department", disableSortBy: true },
            { Header: "Designation", accessor: "designation", disableSortBy: true },
            {
                Header: "Punch In",
                accessor: "punch_in",
                id: "clockIn",
                disableSortBy: false,
                Cell: ({ row }) => {
                    const { punch_in, status, on_time } = row.original;

                    if (["absent", "leave"].includes(status?.toLowerCase()))
                        return <div style={{ minHeight: "20px" }} />;

                    // On Time / Late Entry label
                    const timingLabel =
                        on_time === true
                            ? { text: "On Time", bg: "#DCFCE7", color: "#166534" }
                            : on_time === false
                                ? { text: "Late Coming", bg: "#FEE2E2", color: "#B91C1C" }
                                : null;

                    return (
                        <div style={{ display: "flex", alignItems: "center", width: "100%" }}>

                            {/* Punch In Time */}
                            <div style={{ fontWeight: 500, whiteSpace: "nowrap", minWidth: "80px" }}>
                                {punch_in || "-"}
                            </div>

                            {/* On Time / Late Entry */}
                            {timingLabel && (
                                <span
                                    style={{
                                        padding: "4px 10px",
                                        borderRadius: "20px",
                                        fontSize: "12px",
                                        fontWeight: 600,
                                        backgroundColor: timingLabel.bg,
                                        color: timingLabel.color,
                                        whiteSpace: "nowrap",
                                        marginLeft: "8px",
                                    }}
                                >
                                    {timingLabel.text}
                                </span>
                            )}

                            <div style={{ borderBottom: "2px dotted #ccc", flexGrow: 1, marginLeft: "8px" }}></div>
                        </div>
                    );
                },
            },



            {
                Header: "Working Hours",
                accessor: "working_hours",
                id: "workingHours",
                disableSortBy: true,
                Cell: ({ row }) => {
                    const { punch_in, punch_out, status } = row.original;
                    if (["absent", "leave"].includes(status?.toLowerCase()))
                        return <div style={{ minHeight: "20px" }} />;

                    const workingHours = calculateWorkingHours(punch_in, punch_out);


                    return (
                        <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    minWidth: "80px",
                                    padding: "0 5px",
                                }}
                            >
                                <span
                                    style={{
                                        fontSize: "12px",
                                        fontWeight: 500,
                                        color: "#7F56DA",
                                        whiteSpace: "nowrap",
                                        textAlign: "center",
                                    }}
                                    title="Working Hours"
                                >
                                    {row.original?.working_hours}
                                </span>
                            </div>

                            <div style={{ borderBottom: "2px dotted #ccc", flexGrow: 1 }}></div>
                        </div>
                    );
                },
            },

            {
                Header: "Punch Out",
                accessor: "punch_out",
                disableSortBy: true,
                Cell: ({ row }) =>
                    ["absent", "leave"].includes(row.original.status?.toLowerCase()) ? (
                        <div style={{ minHeight: "20px" }}></div>
                    ) : (
                        <div style={{ fontWeight: 500, whiteSpace: "nowrap" }}>
                            {row.original.punch_out || "-"}
                        </div>
                    ),
            },

            {
                Header: "Status",
                accessor: "status",
                disableSortBy: false,
                Cell: ({ row }) => {
                    const status = row.original.status?.toLowerCase();

                    const color =
                        status === "late"
                            ? "#F59E0B"
                            : status === "present"
                                ? "#1E7E34"
                                : status === "absent"
                                    ? "#B91C1C"
                                    : status === "leave"
                                        ? "#FF5722"
                                        : "#000";

                    return <div style={{ color, fontWeight: "bold" }}>{row.original.status}</div>;
                },
            },

            {
                Header: "Created At",
                accessor: "created_at",
                disableSortBy: false,
                Cell: ({ row }) => <div>{row.original.created_at}</div>,
            },

            {
                Header: "Report",
                accessor: "report",
                disableSortBy: true,
                Cell: ({ row }) => (
                    <div style={{ cursor: "pointer" }} onClick={() => handleReportShow(row)}>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            width="20"
                            height="20"
                            aria-hidden="true"
                            role="img"
                            style={{ color: "#7F56DA" }}
                        >
                            <title>View report</title>
                            <rect x="3" y="2" width="14" height="20" rx="2" ry="2" fill="none" stroke="currentColor" strokeWidth="1.5" />
                            <path d="M17 2v6h4" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            <rect x="6.2" y="14" width="1.8" height="4" rx="0.3" fill="currentColor" />
                            <rect x="9.2" y="11" width="1.8" height="7" rx="0.3" fill="currentColor" />
                            <rect x="12.2" y="9" width="1.8" height="9" rx="0.3" fill="currentColor" />
                        </svg>
                    </div>
                ),
            },
        ],
        []
    );




    const compareText = (today, yesterday, isPercentage = false) => {
        if (today == null || yesterday == null) return "";

        let diff = today - yesterday;

        // Round to 1 decimal place when percentage
        if (isPercentage) {
            diff = Number(diff.toFixed(1)); // <-- fixes 3.7099999 → 3.7
            const suffix = "%";
            return diff === 0
                ? `▲ 0${suffix} vs yesterday`
                : diff > 0
                    ? `▲ +${diff}${suffix} vs yesterday`
                    : `▼ ${Math.abs(diff)}${suffix} vs yesterday`;
        }

        // For count
        const suffix = "";
        if (diff === 0) return `vs yesterday`;
        if (diff > 0) return `▲ +${diff}${suffix} vs yesterday`;
        return `▼ ${Math.abs(diff)}${suffix} vs yesterday`;
    };



    const [filterStatus, setFilterStatus] = useState(null);

    // -------------------------------
    // Present / Absent employees modal
    // -------------------------------
    const [empModalOpen, setEmpModalOpen] = useState(false);
    const [empModalStatus, setEmpModalStatus] = useState("present");
    const [empModalList, setEmpModalList] = useState([]);
    const [empModalLoading, setEmpModalLoading] = useState(false);

    const openEmployeeModal = async (status) => {
        setEmpModalStatus(status);
        setEmpModalList([]);
        setEmpModalOpen(true);
        setEmpModalLoading(true);
        try {
            const apiDate = format(selectedDate, "yyyy-MM-dd");
            const res = await getData(`staff/attendance-employees/?date=${apiDate}&status=${status}`);
            setEmpModalList(res?.data?.employees || []);
        } catch (error) {
            console.error("Employee list fetch error:", error);
            Notifier.error("Failed to load employee list");
            setEmpModalList([]);
        } finally {
            setEmpModalLoading(false);
        }
    };


    const handleRowClick = (orgId, row) => {

    };

    const sourceData = useMemo(() => empData, [empData]);

    const formattedData = useMemo(() =>
        sourceData?.map((emp, index) => ({
            id: `${emp.employee_id}-${emp.punch_in || ''}-${emp.punch_out || ''}-${index}`,
            employee_id: emp.employee_id,
            unique_code: emp.unique_code,
            employee_name: emp.employee_name || '',
            department: emp.department || '',
            designation: emp.designation || '',
            on_time: emp.on_time ?? false,
            working_hours: emp.working_hours || '',
            punch_in: emp.punch_in || '',
            punch_out: emp.punch_out || '',
            status: emp.status || '',
            created_at: emp.created_at || '',
            profile_picture: emp.profile_picture || '',
            handleRowClick,
        })) || [],
        [empData]); // <-- make sure dependency is empData


    // console.log("formatted",formattedData)

    const searchInputRef = useRef(null);
    useEffect(() => {
        if (searchInputRef.current) {
            searchInputRef.current.focus();
        }
    }, []);





    const handleSearch = async (query) => {
        const cleanQuery = query.trim();
        const apiDate = format(selectedDate, "yyyy-MM-dd");
        // Include both date and search query
        const url = `staff/attendance/?date=${apiDate}&search=${encodeURIComponent(cleanQuery)}`;
        try {
            const res = await getData(url);
            setEmpData(res || []);
        } catch (err) {
            console.error("Search API Error:", err);
            setEmpData([]);
        }
    };



    const debouncedSearch = useMemo(
        () => debounce(handleSearch, 100),
        [selectedDate]
    );

    useEffect(() => {
        return () => debouncedSearch.cancel();
    }, [debouncedSearch]);


    const handleExportExcel = async () => {
        try {

            const apiDate = format(selectedDate, "yyyy-MM-dd");
            const queryString = filterQueryString
                ? `${filterQueryString}&date=${apiDate}`
                : `date=${apiDate}`;
            const urlWithParams = `staff/attendance-export/?${queryString}`;
            const blob = await getBlob(urlWithParams);
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'Attendance_Report.xlsx';
            document.body.appendChild(a);
            a.click();
            a.remove();
        } catch (error) {
            console.error(error);
            Notifier.error('❌ Excel export failed');
        }
    };


    return (
        <>
            {loading ? <SpinnerLoader />
                : (
                    <div className={`container-fluid ${zoomedOut ? "" : "mt-4"}`}
                        style={{
                            height: zoomedOut ? "100vh" : "100%",
                            display: "flex",
                            flexDirection: "column",
                            overflow: "hidden",
                        }}>
                        <div className={`main-wrapper ${zoomedOut ? "zoomed-out" : ""}`} style={{
                            transform: "none", transformOrigin: "top left", transition: "transform 0.3s ease-in-out",
                            pointerEvents: openReport ? "none" : "auto",
                            display: "flex", flexDirection: "column", flex: 1, minHeight: 0, overflow: "hidden",
                        }}>

                            {/* ← plain div instead of div.row — Bootstrap row negative margins break flex height */}
                            <div style={{ flex: 1, minHeight: 0, overflow: "hidden", display: "flex", flexDirection: "column" }}>

                                {/* ← plain div instead of col-12 — Bootstrap col sets flex: 0 0 auto */}
                                <div className="columnsetting" style={{ display: "flex", flexDirection: "column", flex: 1, minHeight: 0, overflow: "hidden", marginTop: "8px" }}>

                                    {/* ── FIXED: Stats Cards ── */}
                                    <div style={{ flexShrink: 0, display: "flex", gap: "20px", flexWrap: "wrap", justifyContent: "space-evenly", padding: "8px 0" }}>
                                        <AttendanceStatus label="Total Employees" bgColor="#39886F0D" icon={presentEmp} iconColor="#39886F" number={stats?.total_employees} onClick={() => setFilterStatus(null)} />
                                        <AttendanceStatus label="Present" bgColor="#39886F0D" icon={presentEmp} iconColor="#39886F" number={stats?.present_today ?? 0} compare={compareText(stats?.attendance_rate_today, stats?.attendance_rate_yesterday, true)} onClick={() => openEmployeeModal("present")} />
                                        <AttendanceStatus label="Absent" icon={absentEmp} bgColor="#FDE2E2" iconColor="red" number={stats?.absent_today} compare={compareText(stats?.absent_today, stats?.absent_yesterday, true)} onClick={() => openEmployeeModal("absent")} />
                                        <AnalogWallClock />
                                    </div>

                                    {/* ── TABS + TABLE ── */}
                                    <div style={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column", overflow: "hidden" }}>

                                        {/* ── FIXED: Live + Search + Date Nav ── */}
                                        {/* ── FIXED: Live + Search + Date Nav ── */}
                                        <div style={{ flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "space-between", padding: "8px 0" }}>
                                            <span className="live-indicators">● Live</span>
                                            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                                <div className="d-flex align-items-center gap-2 dateDayAttendence">
                                                    <button className="btn btn-light" onClick={handlePrev}>‹</button>
                                                    <span className="fw-bold" style={{ minWidth: "200px", textAlign: "center", color: "#7F56DA", fontSize: "16px" }}>
                                                        {format(selectedDate, "EEEE, dd MMMM")}
                                                    </span>
                                                    <button className="btn btn-light" onClick={handleNext}>›</button>
                                                </div>

                                                {/* ← give search a minWidth and stop it shrinking */}
                                                <div style={{ flexShrink: 0, minWidth: "550px" }}>
                                                    <SearchBar data={sourceData} onSearch={debouncedSearch} ref={searchInputRef} placeholder="Search by Employee ID name..." />
                                                </div>

                                                <button className="filter-btn" style={{ flexShrink: 0, background: 'white', border: '1px solid #7F56DA', height: '43px' }} onClick={handleExportExcel}>
                                                    <img src={exporticon} alt="Export" />
                                                </button>
                                            </div>
                                        </div>

                                        {/* ── SCROLLABLE: Table only ── */}
                                        <div style={{
                                            flex: 1,
                                            minHeight: 0,
                                            overflow: "hidden",
                                            display: "flex",
                                            flexDirection: "column",
                                            paddingBottom:'30px'
                                        }} >
                                            {formattedData.length > 0 ? (
                                                <AdvanceTable
                                                    key={formattedData.map(d => d.id).join('-')}
                                                    data={formattedData}
                                                    columns={columns}
                                                    checkbox={false}
                                                    pageCounts={Math.ceil((formattedData?.length || 0) / 10)}
                                                    rowClassName={"attendanceTables"}
                                                    showPagination={false}
                                                    handleSort={handleSort}
                                                    sortField={sortField}
                                                    sortOrder={sortOrder}
                                                />
                                            ) : (
                                                <div className="no-data-message" style={{ textAlign: 'center', padding: '40px', color: '#888' }}>
                                                    No data available
                                                </div>
                                            )}
                                        </div>

                                    </div>
                                </div>
                            </div>

                            {!openReport && (
                                <div className="zoom-btn-container">
                                    <button className={`zoom-btn ${zoomedOut ? "zoomed-out" : ""}`} onClick={toggleZoom} title={zoomedOut ? "Minimise Screen" : "Full Screen"}>
                                        {!zoomedOut ? (
                                            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M4 15V18C4 19.1046 4.89543 20 6 20H9M15.2173 20H18C19.1046 20 20 19.1046 20 18V15M20 9V6C20 4.89543 19.1046 4 18 4H15M4 9V6C4 4.89543 4.89543 4 6 4H9" stroke="#7F56DA" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                        ) : (
                                            <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                                <g id="SVGRepo_iconCarrier">
                                                    <path d="M22.154 2.554L16.707 8H21v1h-6V3h1v4.293l5.446-5.447zm-19.6 19.6L8 16.707V21h1v-6H3v1h4.293l-5.447 5.446zm19.6-.707L16.707 16H21v-1h-6v6h1v-4.293l5.446 5.446zM1.846 2.554L7.293 8H3v1h6V3H8v4.293L2.554 1.846z" stroke="#7F56DA" />
                                                    <path fill="none" d="M0 0h24v24H0z" />
                                                </g>
                                            </svg>
                                        )}
                                    </button>
                                </div>
                            )}
                        </div>

                        <SideDrawer isOpen={openReport} onClose={() => setOpenReport(false)} zoomedOut={zoomedOut}>
                            <AttendanceReport
                                zoomedOut={zoomedOut}
                                selectedEmployee={selectedEmployee}
                                loadingSummary={loadingSummary}
                                summary={summary}
                                reportMonth={reportMonth}
                                reportYear={reportYear}
                                setSelectedEmployee={setSelectedEmployee}
                                setSummary={setSummary}
                                setLoadingSummary={setLoadingSummary}
                                selectedEmployeeId={selectedEmployeeId}
                            />
                        </SideDrawer>

                        <AttendanceEmployeeModal
                            isOpen={empModalOpen}
                            onClose={() => setEmpModalOpen(false)}
                            status={empModalStatus}
                            dateLabel={format(selectedDate, "EEEE, dd MMMM")}
                            employees={empModalList}
                            loading={empModalLoading}
                        />
                    </div>

                )
            }

        </>
    );
};

export default AttendanceDashboard;